module.exports = __webpack_public_path__ + "static/media/greentick.a8e4d8f4.svg";